import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginInfoService } from '@pg-app/auth/services/login-info.service';
import { ResetPinCodeService } from '@pg-app/auth/services/reset-pin-code.service';
import { VerifyTypeSendCodeEnum } from '@nttp/enum/verify-type.enum';
import { AuthyTicketTypeEnum } from '@nttp/enum/authy-ticket-type.enum';
import { MatDialog } from '@angular/material/dialog';
import { CommonDialogComponent } from '@pg-app/common/common-dialog/common-dialog.component';
import { DialogTypeEnum } from '@nttp/enum/common-dialog-type.enum';
import { VerifyCodeErrorEnum } from '@nttp/enum/verify-code-error-type.enum';

@Component({
  selector: 'np-reset-pin-send-code',
  templateUrl: './reset-pin-send-code.component.html',
  styleUrls: ['./reset-pin-send-code.component.scss']
})
export class ResetPinSendCodeComponent implements OnInit {
  tokenHash = '';
  isShowContent = false;

  btnName = 'Reset my memorable number';
  pinCodeError = null;
  ticketType = AuthyTicketTypeEnum.ResetPin;
  email = '';
  sendOnetouchSuccess = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginInfo: LoginInfoService,
    private resetPinCodeService: ResetPinCodeService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    const snapshot = this.route.snapshot;
    this.tokenHash = snapshot.queryParamMap.get('token');

    if (!this.tokenHash) {
      this.router.navigate(['/404']);
    } else {
      this.resetPinCodeService.validateResetPinCodeToken(encodeURIComponent(this.tokenHash)).subscribe(
        res => {
          this.isShowContent = true;
        },
        err => {
          const title =
            err.error && err.error.messages && err.error.messages.length > 0
              ? err.error.messages[0]
              : 'This Reset Pin Link has been used previously. Please generate a new one.';

          this.dialog.open(CommonDialogComponent, {
            data: {
              title: title,
              dialogType: DialogTypeEnum.Success,
              routingUrl: '/auth/login'
            },
            disableClose: true
          });
        }
      );
    }
  }

  sendCode(event = null) {
    this.pinCodeError = null;
    const params = {
      tokenHash: this.tokenHash,
      verificationType: event ? event.method : VerifyTypeSendCodeEnum.Authy,
      ticketType: AuthyTicketTypeEnum.ResetPin
    };

    this.resetPinCodeService.forgotPinSendVerificationCode(params).subscribe(
      res => {
        this.loginInfo.tokenHash = res.token;
        if (event && event.isTryAgain) {
          this.pinCodeError = VerifyCodeErrorEnum.ResendCode;
        }

        if (!event) {
          this.sendOnetouchSuccess = true;
          this.email = res.email;
        }
      },
      err => {
        this.router.navigate(['auth/login']);
      }
    );
  }

  passedOneTouch() {
    this.router.navigate(['auth/login/change-memorable-number']);
  }

  checkCode(event) {
    this.pinCodeError = null;
    this.resetPinCodeService
      .verifyCode({
        tokenHash: this.tokenHash,
        verificationCode: event.code,
        verificationType: event.verificationType
      })
      .subscribe(
        res => {
          this.router.navigate(['auth/login/change-memorable-number']);
        },
        error => {
          this.pinCodeError = VerifyCodeErrorEnum.InvalidCode;
        }
      );
  }

  exceedInvalidCode() {
    this.router.navigate(['auth/login/login-error-phone']);
  }
}
